import { PaymentMethod, EBEPaymentMethodsName } from '../contracts';

const EXPRESS_CHECKOUT_APMS = [
  EBEPaymentMethodsName.apple,
  EBEPaymentMethodsName.google,
  EBEPaymentMethodsName.paypal,
];

const EXCLUDED_AMPS = ['link'];

export function getCardPaymentMethod(paymentMethods: PaymentMethod[]) {
  const filteredApms = paymentMethods?.filter(
    (pm) =>
      !EXPRESS_CHECKOUT_APMS.includes(pm.paymentMethodName as EBEPaymentMethodsName) &&
      !EXCLUDED_AMPS.includes(pm.paymentMethodName)
  );
  return filteredApms?.find((pm) => pm.paymentMethodName === EBEPaymentMethodsName.card);
}
